module.exports = __webpack_public_path__ + "static/media/social.b1c0c2df.JPG";